// import React, { useEffect, useState, useMemo } from 'react';
// import {
//   Box,
//   Grid,
//   Select,
//   MenuItem,
//   Button,
//   DialogActions,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   ToggleButtonGroup,
//   ToggleButton,
//   IconButton,
//   CircularProgress,
//   Typography,
//   InputAdornment,
//   TextField,
// } from '@mui/material';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import CheckboxInputs from 'src/components/inputs/CheckboxInputs';
// import { MdDelete } from "react-icons/md";
// import { FaRegEdit } from "react-icons/fa";
// import { AiOutlineInfoCircle } from "react-icons/ai";
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   setUpdateCount,
//   clearUpdateCount,
//   updateProductsData,
//   updateSingleProductField,
//   updateProductInState,
//   removeProductsFromState,
//   clearAllUpdateCounts
// } from 'src/redux/slices/productSlice';
// import TextInputs from 'src/components/inputs/TextInputs';
// import { Add, Remove } from '@mui/icons-material';
// import { changeDateFormate } from 'src/utils/dateutils';
// import SelectInputs from 'src/components/inputs/SelectInputs';

// const taxStatusOptions = [
//   { value: 'withTax', label: 'Inclusive' },
//   { value: 'withoutTax', label: 'Exclusive' },
//   // { value: 'noGst', label: 'No GST' },
// ];

// const Products = ({ checkedProducts, setCheckedProducts }) => {
//   const dispatch = useDispatch();
//   const [isAllChecked, setIsAllChecked] = useState(false);
//   const [selectItemId, setSelectItemId] = useState('');
//   const [openDialogue, setOpenDialogue] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);
//   const [deleteLoading, setDeleteLoading] = useState(false);
//   const [loadingProductId, setLoadingProductId] = useState('');
//   const [productDetails, setProductDetails] = useState(null);
//   const [open, setOpen] = useState(false);
//   const [hoveredItemId, setHoveredItemId] = useState(null);
//   const [historyType, setHistoryType] = useState('add');

//   const {
//     deleteProduct,
//     updateProduct,
//     addProductCount,
//     setShowMessage,
//     activeBranchId,
//     getProductDetails,
//     branchData
//   } = useMain();

//   const {
//     updateCount,
//     incentiveTypes,
//     updateProductData,
//     data
//   } = useSelector((state) => ({
//     updateCount: state.product.updateCount,
//     incentiveTypes: state.product.incentiveTypes,
//     updateProductData: state.product.updatedProductsData,
//     data: state.product.displayedProducts
//   }));
//   const hasGstNumber = Boolean(String(branchData?.gstNumber || '').trim());

//   const taxableValue = useMemo(() => {
//     const p = Number(updateProductData?.sellPrice) || 0;
//     if (!hasGstNumber) {
//       return p.toFixed(2);
//     }
//     const gstRate = Number(updateProductData?.GST) || 0;
//     if (updateProductData?.taxStatus === 'withTax' && gstRate > 0) {
//       return (p / (1 + gstRate / 100)).toFixed(2);
//     }
//     return p.toFixed(2);
//   }, [hasGstNumber, updateProductData?.sellPrice, updateProductData?.GST, updateProductData?.taxStatus]);

//   const handleDetails = async (id) => {
//     try {
//       const res = await getProductDetails(id, activeBranchId);
//       if (res) {
//         setProductDetails(res);
//         setOpen(true);
//       } else {
//         setShowMessage({ message: 'Failed to fetch product details', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something Went Wrong', messageType: 'error' });
//     }
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setProductDetails(null);
//   };

//   const handleUpdate = (item) => {
//     if (!item) return;
//     setSelectItemId(item._id);

//     const { branchDetails, createdAt, updatedAt, __v, _id, availability, ...rest } = item || {};
//     dispatch(updateProductsData({ ...rest }));
//     setOpenDialogue(true);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     dispatch(updateSingleProductField({ name, value }));
//   };

//   const handleCloseDialogue = () => {
//     setOpenDialogue(false);
//   };

//   const hadleupdateProductData = async () => {
//     try {
//       setLoading(true);
//       if (!updateProductData) {
//         setShowMessage({ message: 'Product data is missing', messageType: 'error' });
//         return;
//       }

//       const cleanedUpdateData = {
//         ...updateProductData,
//         GST: hasGstNumber ? updateProductData.GST : 0,
//         taxStatus: hasGstNumber ? updateProductData.taxStatus : 'noGst',
//       };

//       const {
//         availability,
//         usedProductCount,
//         redemptionHistory,
//         ...updateDataWithoutAvailability
//       } = {
//         ...cleanedUpdateData,
//         incentiveType: updateProductData.incentiveType || '%'
//       };
//       // console.log(updateDataWithoutAvailability)
//       // return

//       const res = await updateProduct(
//         selectItemId,
//         { ...updateDataWithoutAvailability, taxableValue },
//         `?branchId=${activeBranchId}`
//       );

//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Product updated successfully',
//           messageType: 'success',
//         });
//         dispatch(updateProductInState({
//           _id: selectItemId,
//           ...updateDataWithoutAvailability,
//           taxableValue
//         }));
//       } else {
//         setShowMessage({
//           message: res.message || 'Failed to update product',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something went wrong',
//         messageType: 'error',
//       });
//     } finally {
//       setLoading(false);
//       setOpenDialogue(false);
//     }
//   };

//   const handleDeleteField = (id) => {
//     setDeleteId(id);
//     setOpenDeleteDialog(true);
//   };

//   const confirmDelete = async () => {
//     setDeleteLoading(true);
//     try {
//       const res = await deleteProduct(deleteId, `?branchId=${activeBranchId}`);
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Product deleted successfully',
//           messageType: 'success',
//         });

//         // Remove the deleted product from Redux state directly
//         dispatch(removeProductsFromState([deleteId]));

//       } else {
//         setShowMessage({
//           message: res.message || 'Product not deleted',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something went wrong',
//         messageType: 'error',
//       });
//     } finally {
//       setOpenDeleteDialog(false);
//       setDeleteId(null);
//       setDeleteLoading(false);
//     }
//   };

//   const handleCloseDeleteDialog = () => {
//     setOpenDeleteDialog(false);
//     setDeleteId(null);
//   };

//   const handleAllCheckboxChange = () => {
//     if (isAllChecked) {
//       setCheckedProducts([]);
//     } else {
//       setCheckedProducts([...data]);
//     }
//     setIsAllChecked(!isAllChecked);
//   };

//   const handleSignleCheckboxChange = (productId) => {
//     if (checkedProducts.some((check) => check._id === productId)) {
//       setCheckedProducts((prev) => prev.filter((check) => check._id !== productId));
//     } else {
//       const checked = data.find((item) => item._id === productId);
//       if (checked) {
//         setCheckedProducts((prev) => [...prev, checked]);
//       }
//     }
//   };

//   useEffect(() => {
//     setIsAllChecked(data?.length > 0 && checkedProducts?.length === data?.length);
//   }, [checkedProducts, data]);

//   const handleIncentiveTypeChange = (event, newValue) => {
//     if (newValue !== null) {
//       dispatch(updateSingleProductField({ name: 'incentiveType', value: newValue }));
//     }
//   };

//   const handleCountChange = (item, e) => {
//     const { value } = e.target;
//     if (value === '') {
//       dispatch(setUpdateCount({ productId: item._id, count: '' }));
//     } else {
//       const numValue = parseInt(value, 10);
//       if (!isNaN(numValue)) {
//         dispatch(setUpdateCount({ productId: item._id, count: numValue }));
//       }
//     }
//   };

//   const handleCountButton = async (item) => {
//     const updatedCount = updateCount[item._id];
//     if (!updatedCount || isNaN(updatedCount)) {
//       setShowMessage({ message: 'Please enter a valid count', messageType: 'error' });
//       return;
//     }

//     try {
//       setLoadingProductId(item._id);
//       setLoading(true);

//       const res = await addProductCount(
//         item._id,
//         { productCount: Number(updatedCount) },
//         activeBranchId
//       );

//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Product count updated successfully',
//           messageType: 'success'
//         });

//         // Update the product count in Redux state directly
//         dispatch(updateProductInState({
//           _id: item._id,
//           ...item,
//           productCount: (parseInt(item.productCount) || 0) + parseInt(updatedCount)
//         }));

//         dispatch(clearUpdateCount(item._id));
//       } else {
//         setShowMessage({
//           message: res.message || 'Product count not updated',
//           messageType: 'error'
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something Went Wrong',
//         messageType: 'error'
//       });
//     } finally {
//       setLoading(false);
//       setLoadingProductId('');
//     }
//   };

//   useEffect(() => {
//     return () => {
//       dispatch(clearAllUpdateCounts());
//     };
//   }, []);

//   const trimTo15Chars = (text) => {
//     if (!text) return "N/A";
//     return text.length > 15 ? text.substring(0, 15) + "..." : text;
//   };
//    const productGridTemplate = '26px 120px 75px 75px 55px 60px 60px 75px 95px 65px 120px 175px';
//   const productGridRowStyle = {
//     display: 'grid',
//     gridTemplateColumns: productGridTemplate,
//     alignItems: 'center',
//     columnGap: '4px',
//   };

//   return (
//     <Box sx={{ overflow: 'auto', width: '100%' }}>
//       <table className="table-container mt-3" style={{ width: '100%' }}>
//         <thead className="table-thead">
//           <tr style={productGridRowStyle}>
//             <th style={{ padding: '8px' }}>
//               <CheckboxInputs
//                 type={'Heading'}
//                 isAllChecked={isAllChecked}
//                 handleAllCheckboxChange={handleAllCheckboxChange}
//               />
//             </th>
//             <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center'}}>Product Name</th>
//             <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>HSN Code</th>
//             <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>Volume</th>
//             <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>Count</th>
//             <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>Sell (₹)</th>
//             <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>MRP</th>
//             <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>Reward</th>
//             <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>Staff Incentive</th>
//             <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>GST %</th>
//             <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>Actions</th>
//             <th style={{ padding: '10px', whiteSpace: 'nowrap', textAlign: 'center' }}>Increase Count</th>
//           </tr>
//         </thead>
//         <tbody className="table-tbody">
//       {data?.map((item) => (
//             <tr key={item._id} style={productGridRowStyle}>
//               <td style={{ padding: '8px' }}>
//                 <CheckboxInputs
//                   type={'content'}
//                   handleSignleCheckboxChange={handleSignleCheckboxChange}
//                   checkedItems={checkedProducts}
//                   fieldId={item?._id}
//                 />
//               </td>

//               {/* productName with trim + popup */}
//               <td
//                 style={{
//                   padding: '8px',
//                   position: 'relative', // important for popup
//                   textAlign: 'center',
//                 }}
//                 onMouseEnter={() => setHoveredItemId(item._id)}
//                 onMouseLeave={() => setHoveredItemId(null)}
//               >
//                 <div
//                   style={{
//                     whiteSpace: 'nowrap',
//                     overflow: 'hidden',
//                     textOverflow: 'ellipsis',
//                     maxWidth: '100%',
//                     cursor: 'pointer',
//                   }}
//                 >
//                   {trimTo15Chars(item?.productName)}
//                 </div>

//                 {hoveredItemId === item._id && (
//                   <div
//                     style={{
//                       position: 'absolute',
//                       top: '100%',
//                       left: 0,
//                       backgroundColor: '#dfe3f8',
//                       border: '1px solid #ccc',
//                       padding: '6px 10px',
//                       borderRadius: '5px',
//                       zIndex: 100,
//                       boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
//                       whiteSpace: 'normal',
//                       maxWidth: '250px',
//                     }}
//                   >
//                     {item?.productName}
//                   </div>
//                 )}
//               </td>
//              <td style={{ padding: '8px', textAlign: 'center' }}>{item?.hsnCode || '-'}</td>
//               <td style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>{`${item?.volume || ''} ${item?.unit || ''
//                 }`}</td>
//               <td style={{ padding: '8px', textAlign: 'center' }}>{item?.productCount || 0}</td>
//               <td style={{ padding: '8px', textAlign: 'center' }}>{item?.sellPrice || 0}</td>
//               <td style={{ padding: '8px', textAlign: 'center' }}>{item?.mrp || 0}</td>
//               <td style={{ padding: '8px', textAlign: 'center' }}>{item?.rewardPoints || 0}</td>
//               <td style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>
//                 {item?.staffIncentive ? `${item.staffIncentive} ${item?.incentiveType || '%'}` : ''}
//               </td>
//               <td style={{ padding: '8px', textAlign: 'center' }}>
//                 {
//                   item.GST ?? 0
//                 }
//               </td>
//               <td style={{ padding: '8px', textAlign: 'center' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                   <IconButton
//                     onClick={() => handleDetails(item._id)}
//                     color="primary"
//                     title="View Details"
//                     size="small"
//                   >
//                     <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem' }} />
//                   </IconButton>
//                   <IconButton
//                     onClick={() => handleUpdate(item)}
//                     color="secondary"
//                     title="Update"
//                     size="small"
//                   >
//                     <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
//                   </IconButton>
//                   <IconButton
//                     onClick={() => handleDeleteField(item._id)}
//                     color="error"
//                     title="Delete"
//                     size="small"
//                   >
//                     <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem' }} />
//                   </IconButton>
//                 </Box>
//               </td>
//              <td style={{ padding: '0px' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <TextField
//                     type="number"
//                     // value={updateCount[item._id] || ''}
//                     value={updateCount[item._id] ?? ''}
//                     onChange={(e) => handleCountChange(item, e)}
//                     size="small"
//                     sx={{
//                       width: '200px',
//                       backgroundColor: item?.productCount < 5 ? '#f5f5f5' : 'white',
//                       '& .MuiOutlinedInput-root': {
//                         paddingLeft: '0px',
//                         paddingRight: '0px',
//                       },
//                       '& input': {
//                         textAlign: 'center',
//                         padding: '8px 0px',
//                         color: 'black',
//                       },
//                     }}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <IconButton
//                             size="small"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               const currentValue = parseInt(updateCount[item._id] || 0);
//                               dispatch(
//                                 setUpdateCount({
//                                   productId: item._id,
//                                   count: currentValue - 1,
//                                 }),
//                               );
//                             }}
//                           // disabled={parseInt(updateCount[item._id] || 0) <= 0}
//                           >
//                             <Remove fontSize="small" />
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <IconButton
//                             size="small"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               const currentValue = parseInt(updateCount[item._id] || 0);
//                               dispatch(
//                                 setUpdateCount({
//                                   productId: item._id,
//                                   count: currentValue + 1,
//                                 }),
//                               );
//                             }}
//                           >
//                             <Add fontSize="small" />
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                     }}
//                   />

//                   <Button
//                     variant="contained"
//                     size="small"
//                     onClick={() => handleCountButton(item)}
//                     // disabled={item?.productCount < 5 || !updateCount[item._id]}
//                     sx={{
//                       minWidth: '60px',
//                       height: '40px',
//                       backgroundColor: item?.productCount < 5 ? '#e0e0e0' : '#4CAF50',
//                       color: item?.productCount < 5 ? '#757575' : 'white',
//                       '&:hover': {
//                         backgroundColor: item?.productCount < 5 ? '#e0e0e0' : '#43A047',
//                       },
//                     }}
//                   >
//                     {loading && loadingProductId === item._id ? (
//                       <CircularProgress size={20} color="inherit" />
//                     ) : (
//                       'Add'
//                     )}
//                   </Button>
//                 </Box>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {deleteLoading && <ShowLoader />}

//       <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
//         <DialogTitle>Confirm Deletion</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Are you sure you want to delete this product?</DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDeleteDialog} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={confirmDelete} color="secondary">
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Typography variant="h5" style={{ fontWeight: 'bold', textAlign: 'center' }}>
//             Product Details
//           </Typography>
//         </DialogTitle>
//         <DialogContent style={{ padding: '20px' }}>
//           {productDetails ? (
//             <>
//               <Typography variant="h6" style={{ marginBottom: '10px' }}>
//                 Product Name: {productDetails.productName || 'N/A'}
//               </Typography>
//                   <Typography variant="h6" style={{ marginBottom: '10px' }}>
//                 HSN Code: {productDetails.hsnCode || 'N/A'}
//               </Typography>
//               <Typography variant="body1" style={{ marginBottom: '10px' }}>
//                 Available Count: {productDetails.productCount || 0}
//               </Typography>
//               <Typography variant="body1" style={{ marginBottom: '10px' }}>
//                 MRP: ₹{productDetails.mrp || 'N/A'}
//               </Typography>
//               <Typography variant="body1" style={{ marginBottom: '10px' }}>
//                 Selling Price: ₹{productDetails.sellPrice || 'N/A'}
//               </Typography>
//               <Typography variant="body1" style={{ marginBottom: '10px' }}>
//                 Unit: {productDetails.unit || 'N/A'}
//               </Typography>
//               <Typography
//                 variant="h6"
//                 style={{ marginTop: '20px', fontWeight: 'bold', textAlign: 'center' }}
//               >
//                 Product Add History:
//               </Typography>
//               {productDetails.updatedOn?.length > 0 ? (
//                 <table style={{ width: '100%', marginTop: '10px', borderCollapse: 'collapse' }}>
//                   <thead>
//                     <tr>
//                       <th
//                         style={{
//                           textAlign: 'left',
//                           padding: '8px',
//                           borderBottom: '1px solid #ddd',
//                         }}
//                       >
//                         Date
//                       </th>
//                       <th
//                         style={{
//                           textAlign: 'left',
//                           padding: '8px',
//                           borderBottom: '1px solid #ddd',
//                         }}
//                       >
//                         Count
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {productDetails.updatedOn.map((update) => (
//                       <tr key={update._id}>
//                         <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
//                           {changeDateFormate(update.dateOfAddingProduct) || 'N/A'}
//                         </td>
//                         <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
//                           {update.productAddedCount || 0}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               ) : (
//                 <Typography variant="body2">No updates available</Typography>
//               )}
//             </>
//           ) : (
//             <Typography variant="body2">Loading...</Typography>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={handleClose}
//             variant="contained"
//             color="primary"
//             style={{ margin: '10px auto' }}
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog> */}

//       <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Typography variant="h5" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
//             Product Details
//           </Typography>
//         </DialogTitle>

//         <DialogContent sx={{ padding: '20px' }}>
//           {productDetails ? (
//             <>
//               <Typography variant="h6" mb={1}>
//                 Product Name: {productDetails.productName || 'N/A'}
//               </Typography>

//               <Typography variant="body1" mb={1}>
//                 Available Count: {productDetails.productCount || 0}
//               </Typography>

//               <Typography variant="body1" mb={1}>
//                 MRP: ₹{productDetails.mrp || 'N/A'}
//               </Typography>

//               <Typography variant="body1" mb={1}>
//                 Selling Price: ₹{productDetails.sellPrice || 'N/A'}
//               </Typography>

//               <Typography variant="body1" mb={2}>
//                 Unit: {productDetails.unit || 'N/A'}
//               </Typography>

//               {/* 🔁 Toggle Buttons */}
//               <ToggleButtonGroup
//                 value={historyType}
//                 exclusive
//                 onChange={(e, value) => value && setHistoryType(value)}
//                 fullWidth
//                 sx={{ mb: 2 }}
//               >
//                 <ToggleButton value="add">Add History</ToggleButton>
//                 <ToggleButton value="redeem">Redemption History</ToggleButton>
//               </ToggleButtonGroup>

//               {/* ================= ADD HISTORY ================= */}
//               {historyType === 'add' && (
//                 <>
//                   <Typography variant="h6" textAlign="center" fontWeight="bold">
//                     Product Add History
//                   </Typography>

//                   {/* {productDetails.updatedOn?.length > 0 ? (
//               <table style={{ width: '100%', marginTop: 10 }}>
//                 <thead>
//                   <tr>
//                     <th style={{ textAlign: 'left' }}>Date</th>
//                     <th style={{ textAlign: 'left' }}>Added Count</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {productDetails.updatedOn.map((item) => (
//                     <tr key={item._id}>
//                       <td>{changeDateFormate(item.dateOfAddingProduct)}</td>
//                       <td>{item.productAddedCount}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             ) : (
//               <Typography>No add history available</Typography>
//             )} */}
//                   {productDetails.updatedOn?.length > 0 ? (
//                     <table style={{ width: '100%', marginTop: '10px', borderCollapse: 'collapse' }}>
//                       <thead>
//                         <tr>
//                           <th
//                             style={{
//                               textAlign: 'left',
//                               padding: '8px',
//                               borderBottom: '1px solid #ddd',
//                             }}
//                           >
//                             Date
//                           </th>
//                           <th
//                             style={{
//                               textAlign: 'left',
//                               padding: '8px',
//                               borderBottom: '1px solid #ddd',
//                             }}
//                           >
//                             Count
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {productDetails.updatedOn.map((update) => (
//                           <tr key={update._id}>
//                             <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
//                               {changeDateFormate(update.dateOfAddingProduct) || 'N/A'}
//                             </td>
//                             <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
//                               {update.productAddedCount || 0}
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   ) : (
//                     <Typography variant="body2">No updates available</Typography>
//                   )}
//                 </>
//               )}

//               {/* ================= REDEMPTION HISTORY ================= */}
//               {historyType === 'redeem' && (
//                 <>
//                   <Typography variant="h6" textAlign="center" fontWeight="bold">
//                     Product Redemption History
//                   </Typography>

//                   {productDetails.redemptionHistory?.length > 0 ? (
//                     <table style={{ width: '100%', marginTop: 10 }}>
//                       <thead>
//                         <tr>
//                           <th
//                             style={{
//                               textAlign: 'left',
//                               padding: '8px',
//                               borderBottom: '1px solid #ddd',
//                             }}
//                           >
//                             Date
//                           </th>
//                           {/* <th style={{ textAlign: 'left' }}>Date</th> */}
//                           <th
//                             style={{
//                               textAlign: 'left',
//                               padding: '8px',
//                               borderBottom: '1px solid #ddd',
//                             }}
//                           >
//                             Redeemed
//                           </th>
//                           {/* <th style={{ textAlign: 'left' }}>Redeemed</th> */}
//                           <th
//                             style={{
//                               textAlign: 'left',
//                               padding: '8px',
//                               borderBottom: '1px solid #ddd',
//                             }}
//                           >
//                             Client
//                           </th>
//                           {/* <th style={{ textAlign: 'left' }}>Client</th> */}
//                           {/* <th style={{ textAlign: 'left' }}>Bill ID</th> */}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {productDetails.redemptionHistory.map((item) => (
//                           <tr key={item._id}>
//                             <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
//                               {changeDateFormate(item.dateOfProductRedemption) || 'N/A'}
//                             </td>
//                             <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
//                               {item.redeemedProductCount || 0}
//                             </td>
//                             <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
//                               {item.billId?.clientName || '-'}
//                             </td>
//                           </tr>
//                           // <tr key={item._id}>
//                           //   <td>{changeDateFormate(item.dateOfProductRedemption)}</td>
//                           //   <td>{item.redeemedProductCount}</td>
//                           //   <td>{item.billId?.clientName || '-'}</td>
//                           //   {/* <td>{item.billId?._id || '-'}</td> */}
//                           // </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   ) : (
//                     <Typography>No redemption history available</Typography>
//                   )}
//                 </>
//               )}
//             </>
//           ) : (
//             <Typography>Loading...</Typography>
//           )}
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={handleClose} variant="contained">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
//         <DialogTitle>Product Details</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Here you can update Product details.</DialogContentText>
//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={3} justify="center">
//               <Grid item xs={12} md={4}>
//                 <TextInputs
//                   title={'Product Name'}
//                   name={'productName'}
//                   value={updateProductData?.productName || ''}
//                   handleChange={handleChange}
//                   type={'text'}
//                   required={false}
//                 />
//               </Grid>
//               <Grid item xs={12} md={4} container>
//                 <Grid item xs={12} container spacing={3} alignItems="center">
//                   <Grid item xs={12} md={6}>
//                     <TextInputs
//                       title={'MRP'}
//                       name={'mrp'}
//                       value={updateProductData?.mrp || ''}
//                       handleChange={handleChange}
//                       type={'number'}
//                       required={false}
//                     />
//                   </Grid>
//                   <Grid item xs={12} md={6}>
//                     <TextInputs
//                       title={'Volume'}
//                       name={'volume'}
//                       value={updateProductData?.volume || ''}
//                       handleChange={handleChange}
//                       type={'number'}
//                       min={1}
//                       required={false}
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </Box>

//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={3}>
//                 <div style={{ marginBottom: '5px', fontWeight: 'bold', color: 'black' }}>Unit</div>
//                 <Select
//                   name="unit"
//                   value={updateProductData?.unit || ''}
//                   onChange={handleChange}
//                   fullWidth
//                 >
//                   {['ml', 'l', 'gm', 'kg'].map((type) => (
//                     <MenuItem key={type} value={type}>
//                       {type}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </Grid>
//               <Grid item xs={12} md={3}>
//                 <TextInputs
//                   title={'Product Count'}
//                   name={'productCount'}
//                   value={updateProductData?.productCount || ''}
//                   handleChange={handleChange}
//                   type={'number'}
//                   required={false}
//                   disabled
//                 />
//               </Grid>
//               <Grid item xs={12} md={3}>
//                 <TextInputs
//                   title={'Sell Price'}
//                   name={'sellPrice'}
//                   value={updateProductData?.sellPrice || ''}
//                   handleChange={handleChange}
//                   type={'number'}
//                   required={false}
//                 />
//               </Grid>
//               {hasGstNumber && (
//                 <Grid item xs={12} md={4}>
//                   <SelectInputs
//                     title={'Tax Status'}
//                     options={taxStatusOptions}
//                     name={'taxStatus'}
//                     value={updateProductData?.taxStatus || 'noGst'}
//                     handleChange={handleChange}
//                     optionTitle={'label'}
//                     optionValue={'value'}
//                     required={false}
//                   />
//                 </Grid>
//               )}
//               {hasGstNumber && (
//                 <Grid item xs={12} md={4}>
//                   <TextInputs
//                     title={'Taxable Value'}
//                     name={'taxableValue'}
//                     value={taxableValue}
//                     type={'text'}
//                     placeholder={'0'}
//                     disabled={true}
//                     required={false}
//                   />
//                 </Grid>
//               )}
//             </Grid>
//           </Box>
//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={3}>
//                 <TextInputs
//                   title={'Reward Points'}
//                   name={'rewardPoints'}
//                   value={updateProductData?.rewardPoints || ''}
//                   handleChange={handleChange}
//                   type={'number'}
//                   required={false}
//                 />
//               </Grid>
//               <Grid item xs={12} md={3}>
//                 <TextInputs
//                   title={'Staff Incentive'}
//                   name={'staffIncentive'}
//                   value={updateProductData?.staffIncentive || ''}
//                   handleChange={handleChange}
//                   type={'number'}
//                   required={false}
//                 />
//               </Grid>
//               <Grid item xs={12} md={3} marginTop={0.1}>
//                 <div style={{ marginBottom: '6px', fontWeight: 'bold', color: 'black' }}>
//                   Incentive Type
//                 </div>
//                 <ToggleButtonGroup
//                   value={updateProductData?.incentiveType || '%'}
//                   exclusive
//                   onChange={handleIncentiveTypeChange}
//                   aria-label="incentive type"
//                   fullWidth
//                   sx={{
//                     borderRadius: '4px',
//                     height: '50px',
//                     backgroundColor: '#f0f0f0',
//                   }}
//                 >
//                   {incentiveTypes.map((type) => (
//                     <ToggleButton
//                       key={type}
//                       value={type}
//                       aria-label={type}
//                       sx={{
//                         color: '#000',
//                         backgroundColor: '#e0e0e0',
//                         height: '3.4rem',
//                         '&.Mui-selected': {
//                           backgroundColor: '#6174DD',
//                           color: '#fff',
//                           '&:hover': {
//                             backgroundColor: '#6174DD',
//                           },
//                         },
//                         '&:not(.Mui-selected)': {
//                           '&:hover': {
//                             backgroundColor: '#d0d0d0',
//                           },
//                         },
//                       }}
//                     >
//                       {type}
//                     </ToggleButton>
//                   ))}
//                 </ToggleButtonGroup>
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextInputs
//                   title={'HSN Code'}
//                   name={'hsnCode'}
//                   value={updateProductData?.hsnCode || ''}
//                   handleChange={handleChange}
//                   type={'text'}
//                   required={false}
//                 />
//               </Grid>
//               {hasGstNumber && (
//                 <Grid item xs={12} md={4}>
//                   <SelectInputs
//                     name={'GST'}
//                     value={updateProductData?.GST}
//                     title={'GST %'}
//                     handleChange={handleChange}
//                     options={[
//                       {
//                         value: 5,
//                         title: '5%'
//                       },
//                       {
//                         value: 12,
//                         title: '12%'
//                       },
//                       {
//                         value: 18,
//                         title: '18%'
//                       },
//                     ]}
//                     optionValue={'value'}
//                     optionTitle={'title'}
//                   />
//                   {/* <TextInputs
//                     title={'GST %'}
//                     name={'GST'}
//                     value={updateProductData?.GST}
//                     handleChange={handleChange}
//                     type={'number'}
//                     required={false}
//                   /> */}
//                 </Grid>
//               )}
//             </Grid>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           {loading ? (
//             <ShowLoader />
//           ) : (
//             <>
//               <div style={{ width: '200px', margin: '3rem auto' }}>
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   color="primary"
//                   sx={{ background: '#6174DD' }}
//                   onClick={handleCloseDialogue}
//                 >
//                   Cancel
//                 </Button>
//               </div>
//               <div style={{ width: '200px', margin: '3rem auto' }}>
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   color="primary"
//                   sx={{ background: '#6174DD' }}
//                   onClick={hadleupdateProductData}
//                 >
//                   Update
//                 </Button>
//               </div>
//             </>
//           )}
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default Products;
import React, { useEffect, useState, useMemo, useRef } from 'react';
import {
  Box,
  Grid,
  Select,
  MenuItem,
  Button,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  ToggleButtonGroup,
  ToggleButton,
  IconButton,
  CircularProgress,
  Typography,
  InputAdornment,
  TextField,
  Autocomplete,
  Tooltip,
} from '@mui/material';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import CheckboxInputs from 'src/components/inputs/CheckboxInputs';
import { MdDelete } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { useDispatch, useSelector } from 'react-redux';
import {
  setUpdateCount,
  clearUpdateCount,
  updateProductsData,
  updateSingleProductField,
  updateProductInState,
  removeProductsFromState,
  clearAllUpdateCounts
} from 'src/redux/slices/productSlice';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ClearIcon from '@mui/icons-material/Clear';
import { Add, Remove } from '@mui/icons-material';
import { changeDateFormate } from 'src/utils/dateutils';
import { getHighlightedText } from 'src/utils/textUtils';
import BulkUploadProductDialog from './components/BulkUploadProductDialog'; // adjust path to match where you saved it

const taxStatusOptions = [
  { value: 'withTax', label: 'Inclusive' },
  { value: 'withoutTax', label: 'Exclusive' },
  // { value: 'noGst', label: 'No GST' },
];

// ---------------------------------------------------------------------------
// Category -> Subcategory mapping (kept in sync with AddProduct.jsx)
// ---------------------------------------------------------------------------
const CATEGORY_SUBCATEGORY_MAP = {
  'Hair Care': ['Shampoo', 'Conditioner', 'Hair Mask', 'Hair Serum', 'Hair Oil', 'Scalp Care'],
  'Hair Styling': [
    'Hair Spray',
    'Hair Wax',
    'Hair Gel',
    'Hair Mousse',
    'Styling Cream',
    'Hair Pomade',
    'Heat Protection',
  ],
  'Hair Color': [
    'Hair Color',
    'Hair Bleach',
    'Developer',
    'Toner',
    'Color Protect',
    'Color Remover',
    'Root Touch-Up',
  ],
  'Skin Care': ['Face Wash', 'Face Scrub', 'Toner', 'Moisturizer', 'Face Serum', 'Sunscreen', 'Face Oil'],
  'Facial & Cleanup': [
    'Facial Kit',
    'Cleanup Kit',
    'Face Mask',
    'Face Peel',
    'Bleach',
    'Facial Cream',
    'Facial Gel',
    'Facial Treatment',
  ],
  'Manicure & Pedicure': [
    'Nail Polish',
    'Nail Remover',
    'Nail Care',
    'Scrub',
    'Cream',
    'Manicure Kit',
    'Pedicure Kit',
    'Nail Tools',
    'Nail Art',
  ],
  Waxing: ['Wax', 'Wax Strips', 'Pre-Wax Care', 'Post-Wax Care', 'Waxing Accessories'],
  Makeup: [
    'Foundation',
    'Concealer',
    'Compact',
    'Primer',
    'Blush',
    'Highlighter',
    'Lipstick',
    'Lip Gloss',
    'Eye Makeup',
    'Eyeshadow',
    'Makeup Remover',
    'Setting Products',
  ],
  'Salon Consumables': [
    'Disposable',
    'Cotton Products',
    'Tissues',
    'Applicators',
    'Foils',
    'Protective Items',
    'Cleaning Supplies',
    'Other Consumables',
  ],
  'Aftercare / Retail': [
    'Hair Aftercare',
    'Hair Treatment',
    'Color Aftercare',
    'Skin Aftercare',
    'Facial Aftercare',
    'Nail Aftercare',
    'Sun Care',
    'Professional Home Kits',
  ],
};

const CATEGORY_OPTIONS = Object.keys(CATEGORY_SUBCATEGORY_MAP);

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

// ---- Shared style helpers (matching AddProduct.jsx) ----
const sectionBoxStyle = {
  border: '1px solid #e8e9f2',
  borderRadius: '12px',
  padding: '22px',
  marginBottom: '20px',
  background: '#fff',
  boxShadow: '0 1px 3px rgba(30,32,60,0.04)',
};

const sectionHeaderStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  marginBottom: '20px',
};

const stepCircleStyle = {
  width: '30px',
  height: '30px',
  minWidth: '30px',
  borderRadius: '50%',
  background: 'linear-gradient(135deg, #6174DD, #7C8FF2)',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 700,
  fontSize: '13px',
  boxShadow: '0 2px 6px rgba(97,116,221,0.35)',
};

const fieldLabelStyle = {
  fontSize: '14px',
  fontWeight: 600,
  marginBottom: '6px',
  display: 'block',
  color: '#212529',
  minHeight: '18px',
};

const helperTextStyle = {
  fontSize: '12px',
  color: '#8a8f98',
  marginTop: '4px',
};

const inputBoxStyle = (hasError) => ({
  display: 'flex',
  alignItems: 'center',
  border: `1px solid ${hasError ? '#e53935' : '#ced4da'}`,
  borderRadius: '6px',
  height: '48px',
  transition: 'border-color 0.2s ease-in-out',
  '&:hover': { borderColor: '#6174DD' },
});

const plainInputStyle = {
  border: 'none',
  outline: 'none',
  flex: 1,
  padding: '0 12px',
  fontSize: '15px',
  background: 'transparent',
  width: '100%',
  height: '100%',
};

const autocompleteSx = (hasError) => ({
  '& .MuiOutlinedInput-root': {
    height: '48px',
    borderRadius: '6px',
    fontSize: '15px',
    '& fieldset': {
      borderColor: hasError ? '#e53935' : '#ced4da',
    },
    '&:hover fieldset': {
      borderColor: '#6174DD',
    },
  },
  '& .MuiInputBase-input': {
    padding: '0 !important',
  },
});

const Products = ({ checkedProducts, setCheckedProducts }) => {
  const dispatch = useDispatch();
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [selectItemId, setSelectItemId] = useState('');
  const [openDialogue, setOpenDialogue] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [loadingProductId, setLoadingProductId] = useState('');
  const [productDetails, setProductDetails] = useState(null);
  const [open, setOpen] = useState(false);
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const [historyType, setHistoryType] = useState('add');
  const [isModalOpen, setIsModalOpen] = useState(false);

  // ---- New state for logo handling in the Update dialog ----
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const fileInputRef = useRef(null);

  const {
    deleteProduct,
    updateProduct,
    addProductCount,
    setShowMessage,
    activeBranchId,
    getProductDetails,
    branchData
  } = useMain();

  const {
    updateCount,
    incentiveTypes,
    updateProductData,
   data,
    filters,
  } = useSelector((state) => ({
    updateCount: state.product.updateCount,
    incentiveTypes: state.product.incentiveTypes,
    updateProductData: state.product.updatedProductsData,
    data: state.product.displayedProducts,
    filters: state.product.filters,
  }));
  const hasGstNumber = Boolean(String(branchData?.gstNumber || '').trim());

  // Subcategory options derived from the currently selected category
  const subcategoryOptions = useMemo(() => {
    return updateProductData?.category ? CATEGORY_SUBCATEGORY_MAP[updateProductData.category] || [] : [];
  }, [updateProductData?.category]);

  const taxableValue = useMemo(() => {
    const p = Number(updateProductData?.sellPrice) || 0;
    if (!hasGstNumber) {
      return p.toFixed(2);
    }
    const gstRate = Number(updateProductData?.GST) || 0;
    if (updateProductData?.taxStatus === 'withTax' && gstRate > 0) {
      return (p / (1 + gstRate / 100)).toFixed(2);
    }
    return p.toFixed(2);
  }, [hasGstNumber, updateProductData?.sellPrice, updateProductData?.GST, updateProductData?.taxStatus]);

  const gstValue = useMemo(() => {
    const p = Number(updateProductData?.sellPrice) || 0;
    const gstRate = Number(updateProductData?.GST) || 0;
    if (!hasGstNumber || gstRate <= 0) return '0.00';
    if (updateProductData?.taxStatus === 'withTax') {
      return (p - Number(taxableValue)).toFixed(2);
    }
    return ((p * gstRate) / 100).toFixed(2);
  }, [hasGstNumber, updateProductData?.sellPrice, updateProductData?.GST, updateProductData?.taxStatus, taxableValue]);
const payableValue = useMemo(() => {
  const sellPrice = Number(updateProductData?.sellPrice) || 0;
  const gst = Number(gstValue) || 0;
  if (updateProductData?.taxStatus === 'withoutTax') {
    return (sellPrice + gst).toFixed(2);
  }
  return sellPrice.toFixed(2);
}, [updateProductData?.sellPrice, gstValue, updateProductData?.taxStatus]);

  const staffEarns = useMemo(() => {
    const price = Number(updateProductData?.sellPrice) || 0;
    const incentive = Number(updateProductData?.staffIncentive) || 0;
    if (!incentive) return '0.00';
    if ((updateProductData?.incentiveType || '%') === '%') {
      return ((price * incentive) / 100).toFixed(2);
    }
    return incentive.toFixed(2);
  }, [updateProductData?.sellPrice, updateProductData?.staffIncentive, updateProductData?.incentiveType]);

  const handleDetails = async (id) => {
    try {
      const res = await getProductDetails(id, activeBranchId);
      if (res) {
        setProductDetails(res);
        setOpen(true);
      } else {
        setShowMessage({ message: 'Failed to fetch product details', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something Went Wrong', messageType: 'error' });
    }
  };

  const handleClose = () => {
    setOpen(false);
    setProductDetails(null);
  };

  const handleUpdate = (item) => {
    if (!item) return;
    setSelectItemId(item._id);

   const { branchDetails, createdAt, updatedAt, __v, _id, availability, mrp, purchasePrice, ...rest } = item || {};
    delete rest.mrp;
    delete rest.purchasePrice;

    // Reset logo/image local state, seed preview with existing logo if present
    setLogoFile(null);
    setImagePreviewUrl(item?.logo?.url || null);

    setOpenDialogue(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateSingleProductField({ name, value }));
  };

  // Remove only leading spaces while typing (spaces between words still work)
  const handleProductNameChange = (e) => {
    dispatch(updateSingleProductField({ name: 'productName', value: e.target.value.trimStart() }));
  };

  // Trims the pasted text, then inserts it at the cursor position
  const handleProductNamePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').trim();
    const { selectionStart, selectionEnd, value } = e.target;
    const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
    dispatch(updateSingleProductField({ name: 'productName', value: next }));
  };

  // Trims trailing spaces when the user leaves the box
  const handleProductNameBlur = (e) => {
    const trimmed = e.target.value.trim();
    if (trimmed !== e.target.value) {
      dispatch(updateSingleProductField({ name: 'productName', value: trimmed }));
    }
  };

  // When category changes, reset subcategory
  const handleCategoryChange = (e, newValue) => {
    dispatch(updateSingleProductField({ name: 'category', value: newValue || '' }));
    dispatch(updateSingleProductField({ name: 'subcategory', value: '' }));
  };

  const handleSubcategoryOpen = () => {
    if (!updateProductData?.category) {
      setShowMessage({
        message: 'Please select a category first.',
        messageType: 'error',
      });
    }
  };

  const handleSubcategoryChange = (e, newValue) => {
    if (!updateProductData?.category) {
      setShowMessage({
        message: 'Please select a category first.',
        messageType: 'error',
      });
      return;
    }
    dispatch(updateSingleProductField({ name: 'subcategory', value: newValue || '' }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (imagePreviewUrl && imagePreviewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(imagePreviewUrl);
    }
    setImagePreviewUrl(null);
    setLogoFile(null);

    if (file) {
      if (file.size > 100 * 1024) {
        setShowMessage({
          message: 'File size must not exceed 100KB.',
          messageType: 'error',
        });
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        return;
      }

      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        const { width, height } = img;
        const aspectRatio = width / height;
        const allowedRatios = [1, 4 / 5, 3 / 4];
        const isAllowed = allowedRatios.some((ratio) => Math.abs(aspectRatio - ratio) < 0.01);

        if (!isAllowed) {
          setShowMessage({
            message: 'Invalid aspect ratio. Allowed ratios are 1:1, 4:5, or 3:4.',
            messageType: 'error',
          });
          URL.revokeObjectURL(objectUrl);
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
        } else {
          setImagePreviewUrl(objectUrl);
          setLogoFile(file);
        }
      };

      img.onerror = () => {
        setShowMessage({
          message: 'Invalid file type. Please upload a valid image.',
          messageType: 'error',
        });
        URL.revokeObjectURL(objectUrl);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      };

      img.src = objectUrl;
    }
  };

  const handleRemoveImage = () => {
    if (imagePreviewUrl && imagePreviewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(imagePreviewUrl);
    }
    setImagePreviewUrl(null);
    setLogoFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleCloseDialogue = () => {
    if (imagePreviewUrl && imagePreviewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(imagePreviewUrl);
    }
    setImagePreviewUrl(null);
    setLogoFile(null);
    setOpenDialogue(false);
  };

  const hadleupdateProductData = async () => {
    try {
      setLoading(true);
      if (!updateProductData) {
        setShowMessage({ message: 'Product data is missing', messageType: 'error' });
        return;
      }

      // Resolve logo: keep existing, use newly picked file, or leave unchanged
      let logoObject = updateProductData?.logo || null;
      if (logoFile) {
        const base64Image = await fileToBase64(logoFile);
        logoObject = { url: base64Image, public_id: logoFile.name };
      }

      const cleanedUpdateData = {
        ...updateProductData,
        GST: hasGstNumber ? updateProductData.GST : 0,
        taxStatus: hasGstNumber ? updateProductData.taxStatus : 'noGst',
        logo: logoObject,
      };

      const {
        availability,
        usedProductCount,
        redemptionHistory,
        mrp,
        purchasePrice,
        ...updateDataWithoutAvailability
      } = {
        ...cleanedUpdateData,
        incentiveType: updateProductData.incentiveType || '%'
      };
      delete updateDataWithoutAvailability.mrp;
      delete updateDataWithoutAvailability.purchasePrice;

      const payload = {
        ...updateDataWithoutAvailability,
        productName: (updateDataWithoutAvailability.productName || '').trim(),
        taxableValue,
      };
      delete payload.mrp;
      delete payload.purchasePrice;

      const res = await updateProduct(
        selectItemId,
        payload,
        `?branchId=${activeBranchId}`
      );

      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Product updated successfully',
          messageType: 'success',
        });
        dispatch(updateProductInState({
        _id: selectItemId,
        ...updateDataWithoutAvailability,
        productName: payload.productName,
        taxableValue
      }));
      } else {
        setShowMessage({
          message: res.message || 'Failed to update product',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      setLoading(false);
      setOpenDialogue(false);
    }
  };

  const handleDeleteField = (id) => {
    setDeleteId(id);
    setOpenDeleteDialog(true);
  };

  const confirmDelete = async () => {
    setDeleteLoading(true);
    try {
      const res = await deleteProduct(deleteId, `?branchId=${activeBranchId}`);
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Product deleted successfully',
          messageType: 'success',
        });

        // Remove the deleted product from Redux state directly
        dispatch(removeProductsFromState([deleteId]));

      } else {
        setShowMessage({
          message: res.message || 'Product not deleted',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      setOpenDeleteDialog(false);
      setDeleteId(null);
      setDeleteLoading(false);
    }
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setDeleteId(null);
  };

  const handleAllCheckboxChange = () => {
    if (isAllChecked) {
      setCheckedProducts([]);
    } else {
      setCheckedProducts([...data]);
    }
    setIsAllChecked(!isAllChecked);
  };

  const handleSignleCheckboxChange = (productId) => {
    if (checkedProducts.some((check) => check._id === productId)) {
      setCheckedProducts((prev) => prev.filter((check) => check._id !== productId));
    } else {
      const checked = data.find((item) => item._id === productId);
      if (checked) {
        setCheckedProducts((prev) => [...prev, checked]);
      }
    }
  };

  useEffect(() => {
    setIsAllChecked(data?.length > 0 && checkedProducts?.length === data?.length);
  }, [checkedProducts, data]);

  const handleIncentiveTypeChange = (event, newValue) => {
    if (newValue !== null) {
      dispatch(updateSingleProductField({ name: 'incentiveType', value: newValue }));
    }
  };

  const handleCountChange = (item, e) => {
    const { value } = e.target;
    dispatch(setUpdateCount({ productId: item._id, count: value }));
  };

  const handleCountButton = async (item) => {
    const updatedCount = updateCount[item._id];
    if (!updatedCount || isNaN(updatedCount)) {
      setShowMessage({ message: 'Please enter a valid count', messageType: 'error' });
      return;
    }

    try {
      setLoadingProductId(item._id);
      setLoading(true);

      const res = await addProductCount(
        item._id,
        { productCount: Number(updatedCount) },
        activeBranchId
      );

      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Product count updated successfully',
          messageType: 'success'
        });

        // Update the product count in Redux state directly
        dispatch(updateProductInState({
          _id: item._id,
          ...item,
          productCount: (parseInt(item.productCount) || 0) + parseInt(updatedCount)
        }));

        dispatch(clearUpdateCount(item._id));
      } else {
        setShowMessage({
          message: res.message || 'Product count not updated',
          messageType: 'error'
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something Went Wrong',
        messageType: 'error'
      });
    } finally {
      setLoading(false);
      setLoadingProductId('');
    }
  };

  useEffect(() => {
    return () => {
      dispatch(clearAllUpdateCounts());
    };
  }, []);

  const trimTo15Chars = (text) => {
    if (!text) return "N/A";
    return text.length > 15 ? text.substring(0, 15) + "..." : text;
  };
  const productGridTemplate = '26px 120px 75px 75px 55px 60px 75px 95px 65px 120px 175px';
  const productGridRowStyle = {
    display: 'grid',
    gridTemplateColumns: productGridTemplate,
    alignItems: 'center',
    columnGap: '4px',
  };

  return (
    <Box sx={{ overflow: 'auto', width: '100%' }}>
      <table className="table-container mt-3" style={{ width: '100%' }}>
        <thead className="table-thead">
          <tr style={productGridRowStyle}>
            <th style={{ padding: '8px' }}>
              <CheckboxInputs
                type={'Heading'}
                isAllChecked={isAllChecked}
                handleAllCheckboxChange={handleAllCheckboxChange}
              />
            </th>
            <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center'}}>Product Name</th>
            <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>HSN Code</th>
            <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>Volume</th>
            <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>Count</th>
            {/* <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>Sell (₹)</th> */}
            <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>MRP</th>
            <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>Reward</th>
            <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>Staff Incentive</th>
            <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>GST %</th>
            <th style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>Actions</th>
            <th style={{ padding: '10px', whiteSpace: 'nowrap', textAlign: 'center' }}>Increase Count</th>
          </tr>
        </thead>
        <tbody className="table-tbody">
      {data?.map((item) => (
            <tr key={item._id} style={productGridRowStyle}>
              <td style={{ padding: '8px' }}>
                <CheckboxInputs
                  type={'content'}
                  handleSignleCheckboxChange={handleSignleCheckboxChange}
                  checkedItems={checkedProducts}
                  fieldId={item?._id}
                />
              </td>

              {/* productName with trim + popup */}
              <td
                style={{
                  padding: '8px',
                  position: 'relative', // important for popup
                  textAlign: 'center',
                }}
                onMouseEnter={() => setHoveredItemId(item._id)}
                onMouseLeave={() => setHoveredItemId(null)}
              >
                <div
                  style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '100%',
                    cursor: 'pointer',
                  }}
                >
                  {getHighlightedText(item?.productName, filters.search)}
                </div>

                {hoveredItemId === item._id && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      backgroundColor: '#dfe3f8',
                      border: '1px solid #ccc',
                      padding: '6px 10px',
                      borderRadius: '5px',
                      zIndex: 100,
                      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                      whiteSpace: 'normal',
                      maxWidth: '250px',
                    }}
                  >
                    {getHighlightedText(item?.productName, filters.search)}
                  </div>
                )}
              </td>
             <td style={{ padding: '8px', textAlign: 'center' }}>{item?.hsnCode || '-'}</td>
              <td style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>{`${item?.volume || ''} ${item?.unit || ''
                }`}</td>
              <td style={{ padding: '8px', textAlign: 'center' }}>{item?.productCount || 0}</td>
              <td style={{ padding: '8px', textAlign: 'center' }}>{item?.sellPrice || 0}</td>
              {/* <td style={{ padding: '8px', textAlign: 'center' }}>{item?.mrp || 0}</td> */}
              <td style={{ padding: '8px', textAlign: 'center' }}>{item?.rewardPoints || 0}</td>
              <td style={{ padding: '8px', whiteSpace: 'nowrap', textAlign: 'center' }}>
                {item?.staffIncentive ? `${item.staffIncentive} ${item?.incentiveType || '%'}` : ''}
              </td>
              <td style={{ padding: '8px', textAlign: 'center' }}>
                {
                  item.GST ?? 0
                }
              </td>
              <td style={{ padding: '8px', textAlign: 'center' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <IconButton
                    onClick={() => handleDetails(item._id)}
                    color="primary"
                    title="View Details"
                    size="small"
                  >
                    <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem' }} />
                  </IconButton>
                  <IconButton
                    onClick={() => handleUpdate(item)}
                    color="secondary"
                    title="Update"
                    size="small"
                  >
                    <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
                  </IconButton>
                  <IconButton
                    onClick={() => handleDeleteField(item._id)}
                    color="error"
                    title="Delete"
                    size="small"
                  >
                    <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem' }} />
                  </IconButton>
                </Box>
              </td>
             <td style={{ padding: '0px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <TextField
                    type="number"
                    // value={updateCount[item._id] || ''}
                    value={updateCount[item._id] ?? 0}
                    onChange={(e) => handleCountChange(item, e)}
                    size="small"
                    sx={{
                      width: '120px',
                      backgroundColor: item?.productCount < 5 ? '#f5f5f5' : 'white',
                      '& .MuiOutlinedInput-root': {
                        paddingLeft: '4px',
                        paddingRight: '4px',
                      },
                      '& input': {
                        textAlign: 'center',
                        padding: '8px 4px',
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              const currentValue = parseInt(updateCount[item._id] || 0);
                              dispatch(
                                setUpdateCount({
                                  productId: item._id,
                                  count: currentValue - 1,
                                }),
                              );
                            }}
                          // disabled={parseInt(updateCount[item._id] || 0) <= 0}
                          >
                            <Remove fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              const currentValue = parseInt(updateCount[item._id] || 0);
                              dispatch(
                                setUpdateCount({
                                  productId: item._id,
                                  count: currentValue + 1,
                                }),
                              );
                            }}
                          >
                            <Add fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleCountButton(item)}
                    // disabled={item?.productCount < 5 || !updateCount[item._id]}
                    sx={{
                      minWidth: '60px',
                      height: '40px',
                      backgroundColor: item?.productCount < 5 ? '#e0e0e0' : '#4CAF50',
                      color: item?.productCount < 5 ? '#757575' : 'white',
                      '&:hover': {
                        backgroundColor: item?.productCount < 5 ? '#e0e0e0' : '#43A047',
                      },
                    }}
                  >
                    {loading && loadingProductId === item._id ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      'Add'
                    )}
                  </Button>
                </Box>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {deleteLoading && <ShowLoader />}

      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete this product?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h5" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
            Product Details
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ padding: '20px' }}>
          {productDetails ? (
            <>
              <Typography variant="h6" mb={1}>
                Product Name: {productDetails.productName || 'N/A'}
              </Typography>

              <Typography variant="body1" mb={1}>
                Available Count: {productDetails.productCount || 0}
              </Typography>

              {/* <Typography variant="body1" mb={1}>
                MRP: ₹{productDetails.mrp || 'N/A'}
              </Typography> */}

              <Typography variant="body1" mb={1}>
                MRP: ₹{productDetails.sellPrice || 'N/A'}
              </Typography>

              <Typography variant="body1" mb={2}>
                Unit: {productDetails.unit || 'N/A'}
              </Typography>

              {/* 🔁 Toggle Buttons */}
              <ToggleButtonGroup
                value={historyType}
                exclusive
                onChange={(e, value) => value && setHistoryType(value)}
                fullWidth
                sx={{ mb: 2 }}
              >
                <ToggleButton value="add">Add History</ToggleButton>
                <ToggleButton value="redeem">Redemption History</ToggleButton>
              </ToggleButtonGroup>

              {/* ================= ADD HISTORY ================= */}
              {historyType === 'add' && (
                <>
                  <Typography variant="h6" textAlign="center" fontWeight="bold">
                    Product Add History
                  </Typography>

                  {productDetails.updatedOn?.length > 0 ? (
                    <table style={{ width: '100%', marginTop: '10px', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th
                            style={{
                              textAlign: 'left',
                              padding: '8px',
                              borderBottom: '1px solid #ddd',
                            }}
                          >
                            Date
                          </th>
                          <th
                            style={{
                              textAlign: 'left',
                              padding: '8px',
                              borderBottom: '1px solid #ddd',
                            }}
                          >
                            Count
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {productDetails.updatedOn.map((update) => (
                          <tr key={update._id}>
                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
                              {changeDateFormate(update.dateOfAddingProduct) || 'N/A'}
                            </td>
                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
                              {update.productAddedCount || 0}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <Typography variant="body2">No updates available</Typography>
                  )}
                </>
              )}

              {/* ================= REDEMPTION HISTORY ================= */}
              {historyType === 'redeem' && (
                <>
                  <Typography variant="h6" textAlign="center" fontWeight="bold">
                    Product Redemption History
                  </Typography>

                  {productDetails.redemptionHistory?.length > 0 ? (
                    <table style={{ width: '100%', marginTop: 10 }}>
                      <thead>
                        <tr>
                          <th
                            style={{
                              textAlign: 'left',
                              padding: '8px',
                              borderBottom: '1px solid #ddd',
                            }}
                          >
                            Date
                          </th>
                          <th
                            style={{
                              textAlign: 'left',
                              padding: '8px',
                              borderBottom: '1px solid #ddd',
                            }}
                          >
                            Redeemed
                          </th>
                          <th
                            style={{
                              textAlign: 'left',
                              padding: '8px',
                              borderBottom: '1px solid #ddd',
                            }}
                          >
                            Client
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {productDetails.redemptionHistory.map((item) => (
                          <tr key={item._id}>
                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
                              {changeDateFormate(item.dateOfProductRedemption) || 'N/A'}
                            </td>
                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
                              {item.redeemedProductCount || 0}
                            </td>
                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
                              {item.billId?.clientName || '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <Typography>No redemption history available</Typography>
                  )}
                </>
              )}
            </>
          ) : (
            <Typography>Loading...</Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* =========================================================
          UPDATE PRODUCT DIALOG — restyled to match AddProduct.jsx
      ========================================================== */}
      <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md" fullWidth>
        <DialogTitle>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Update Product
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ background: '#f7f7fb', paddingTop: '12px' }}>
          {/* 1. Basic Information */}
          <Box sx={sectionBoxStyle}>
            <Box sx={sectionHeaderStyle}>
              <Box sx={stepCircleStyle}>1</Box>
              <Box>
                <div style={{ fontWeight: 700, fontSize: '17px' }}>Basic Information</div>
                <div style={{ fontSize: '13px', color: '#8a8f98' }}>
                  Update basic details about this product.
                </div>
              </Box>
            </Box>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <label style={fieldLabelStyle}>
                  Product Name <span style={{ color: 'red' }}>*</span>
                </label>
                <Box sx={inputBoxStyle(false)}>
                  <input
                    name="productName"
                    value={updateProductData?.productName || ''}
                    onChange={handleProductNameChange}
                    onPaste={handleProductNamePaste}
                    onBlur={handleProductNameBlur}
                    type="text"
                    placeholder="e.g. L'Oréal Shampoo"
                    style={plainInputStyle}
                    autoComplete="off"
                  />
                </Box>
                <div style={helperTextStyle}>This name will appear in billing and inventory.</div>
              </Grid>

              <Grid item xs={12} md={6}>
                <label style={fieldLabelStyle}>Category</label>
                <Autocomplete
                  options={CATEGORY_OPTIONS}
                  value={updateProductData?.category || null}
                  onChange={handleCategoryChange}
                  sx={autocompleteSx(false)}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Search or select category" />
                  )}
                />
                <div style={helperTextStyle}>Choose the product's main category.</div>
              </Grid>

              <Grid item xs={12} md={6}>
                <label style={fieldLabelStyle}>Subcategory</label>
                <Tooltip
                  title={!updateProductData?.category ? 'Please select a category first' : ''}
                  disableHoverListener={Boolean(updateProductData?.category)}
                >
                  <span>
                    <Autocomplete
                      options={subcategoryOptions}
                      value={updateProductData?.subcategory || null}
                      onChange={handleSubcategoryChange}
                      onOpen={handleSubcategoryOpen}
                      disabled={!updateProductData?.category}
                      sx={autocompleteSx(false)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={
                            updateProductData?.category ? 'Search or select subcategory' : 'Select category first'
                          }
                        />
                      )}
                    />
                  </span>
                </Tooltip>
                <div style={helperTextStyle}>
                  {updateProductData?.category
                    ? 'Narrow it down within the category.'
                    : 'Select a category to see available subcategories.'}
                </div>
              </Grid>

              <Grid item xs={12} md={6}>
                <label style={fieldLabelStyle}>
                  HSN Code (Optional){' '}
                  <Tooltip title="Harmonized System Nomenclature code, used for GST reporting.">
                    <InfoOutlinedIcon sx={{ fontSize: 15, color: '#9aa0a6', verticalAlign: 'middle' }} />
                  </Tooltip>
                </label>
                <Box sx={inputBoxStyle(false)}>
                  <input
                    name="hsnCode"
                    value={updateProductData?.hsnCode || ''}
                    onChange={handleChange}
                    type="text"
                    placeholder="e.g. 33051010"
                    style={plainInputStyle}
                  />
                </Box>
                <div style={helperTextStyle}>Used for GST reporting.</div>
              </Grid>

              <Grid item xs={12} md={6}>
                <label style={fieldLabelStyle}>Pack Size</label>
                <Box sx={inputBoxStyle(false)}>
                  <input
                    name="volume"
                    placeholder="500"
                    value={updateProductData?.volume || ''}
                    onChange={handleChange}
                    type="number"
                    min="0"
                    style={plainInputStyle}
                  />
                  <Select
                    name="unit"
                    value={updateProductData?.unit || 'ml'}
                    onChange={handleChange}
                    displayEmpty
                    sx={{
                      background: '#F5F5F7',
                      border: 'none',
                      height: '100%',
                      minWidth: '70px',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      borderTopRightRadius: '6px',
                      borderBottomRightRadius: '6px',
                      '& .MuiSelect-select': {
                        padding: '0 14px',
                        height: '100% !important',
                        display: 'flex',
                        alignItems: 'center',
                      },
                      '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                      borderLeft: '1px solid #ced4da',
                    }}
                  >
                    {['ml', 'l', 'gm', 'kg'].map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
                <div style={helperTextStyle}>Enter the size of one unit/package.</div>
              </Grid>

              <Grid item xs={12}>
                <label style={fieldLabelStyle}>
                  Product Image (Optional){' '}
                  <Tooltip title="Upload an image for your product.">
                    <InfoOutlinedIcon sx={{ fontSize: 15, color: '#9aa0a6', verticalAlign: 'middle' }} />
                  </Tooltip>
                </label>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                  <Button
                    variant="contained"
                    component="label"
                    startIcon={<CloudUploadIcon />}
                    sx={{
                      background: '#6174DD',
                      '&:hover': { background: '#5365c1' },
                      textTransform: 'none',
                      fontSize: '14px',
                      padding: '8px 16px',
                      height: '40px',
                    }}
                  >
                    {imagePreviewUrl ? 'Replace Image' : 'Upload Image'}
                    <input
                      ref={fileInputRef}
                      name="logo"
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      hidden
                    />
                  </Button>

                  {imagePreviewUrl && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Box
                        component="img"
                        src={imagePreviewUrl}
                        alt="Product"
                        sx={{
                          width: 40,
                          height: 40,
                          borderRadius: '6px',
                          objectFit: 'cover',
                          border: '1px solid #e0e0e0',
                        }}
                      />
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          maxWidth: '150px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {logoFile ? logoFile.name : 'Current image'}
                      </Typography>
                      <IconButton size="small" onClick={handleRemoveImage} sx={{ color: '#e53935' }}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  )}
                </Box>
                <div style={helperTextStyle}>Upload a clear image of the product (e.g., JPEG, PNG).</div>
              </Grid>
            </Grid>
          </Box>

          {/* 2. Pricing & Tax */}
          <Box sx={sectionBoxStyle}>
            <Box sx={sectionHeaderStyle}>
              <Box sx={stepCircleStyle}>2</Box>
              <Box>
                <div style={{ fontWeight: 700, fontSize: '17px' }}>Pricing & Tax</div>
                <div style={{ fontSize: '13px', color: '#8a8f98' }}>
                  Update the selling price and tax details.
                </div>
              </Box>
            </Box>

            <Grid container spacing={3}>
              {/* <Grid item xs={12} md={6}> */}
                {/* <label style={fieldLabelStyle}>MRP</label>
                <Box sx={inputBoxStyle(false)}>
                  <span style={{ padding: '0 10px', fontSize: '15px', color: '#666' }}>₹</span>
                  <input
                    name="mrp"
                    placeholder="0.00"
                    value={updateProductData?.mrp || ''}
                    onChange={handleChange}
                    type="number"
                    min="0"
                    style={{ ...plainInputStyle, padding: '0 12px 0 0' }}
                  />
                </Box>
                <div style={helperTextStyle}>Maximum Retail Price</div>
              </Grid> */}

              <Grid item xs={12} md={6}>
                <label style={fieldLabelStyle}>MRP</label>
                <Box sx={inputBoxStyle(false)}>
                  <span style={{ padding: '0 10px', fontSize: '15px', color: '#666' }}>₹</span>
                  <input
                    name="sellPrice"
                    placeholder="0.00"
                    value={updateProductData?.sellPrice || ''}
                    onChange={handleChange}
                    type="number"
                    min="0"
                    style={{ ...plainInputStyle, padding: '0 12px 0 0' }}
                  />
                </Box>
                <div style={helperTextStyle}>Maximum Retail Price</div>
              </Grid>

              {hasGstNumber && (
                <Grid item xs={12} md={6}>
                  <label style={fieldLabelStyle}>GST Rate</label>
                  <Select
                    name="GST"
                    value={updateProductData?.GST || 18}
                    onChange={handleChange}
                    fullWidth
                    sx={{ height: '48px', borderRadius: '6px' }}
                  >
                    {[5, 12, 18].map((rate) => (
                      <MenuItem key={rate} value={rate}>
                        {rate}%
                      </MenuItem>
                    ))}
                  </Select>
                  <div style={helperTextStyle}>Select applicable GST rate</div>
                </Grid>
              )}

              {hasGstNumber && (
                <Grid item xs={12} md={6}>
                  <label style={fieldLabelStyle}>Does Price Include GST?</label>
                  <Select
                    name="taxStatus"
                    value={updateProductData?.taxStatus || 'noGst'}
                    onChange={handleChange}
                    fullWidth
                    sx={{ height: '48px', borderRadius: '6px' }}
                  >
                    {taxStatusOptions.map((opt) => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <div style={helperTextStyle}>Whether the price above includes GST.</div>
                </Grid>
              )}
            </Grid>

            {hasGstNumber && (
              <Box
                sx={{
                  marginTop: '18px',
                  background: 'linear-gradient(135deg, #f5f6fb, #eef0fa)',
                  border: '1px solid #e3e5f5',
                  borderRadius: '8px',
                  padding: '14px 16px',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                  <LocalOfferOutlinedIcon sx={{ fontSize: 18, color: '#6174DD' }} />
                  <span style={{ fontWeight: 700, fontSize: '14px', color: '#6174DD' }}>
                    Price Summary
                  </span>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginBottom: '8px' }}>
                  <span>MRP (Selling Price)</span>
                  <span>₹{Number(updateProductData?.sellPrice || 0).toFixed(2)}</span>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', fontWeight: 700, marginBottom: '8px' }}>
                  <span>Taxable Value</span>
                  <span style={{ color: '#2e7d32' }}>₹{taxableValue}</span>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginBottom: '8px' }}>
                  <span>GST ({updateProductData?.GST || 0}%)</span>
                  <span>₹{gstValue}</span>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', fontWeight: 700, marginTop: '8px' }}>
                  <span>Payable Value</span>
                  <span style={{ color: '#2e7d32' }}>₹{payableValue}</span>
                </Box>
                <div style={{ fontSize: '11px', color: '#8a8f98', marginTop: '8px' }}>
                  This is an auto-calculated value based on your input.
                </div>
              </Box>
            )}
          </Box>

          {/* 3. Inventory */}
          <Box sx={sectionBoxStyle}>
            <Box sx={sectionHeaderStyle}>
              <Box sx={stepCircleStyle}>3</Box>
              <Box>
                <div style={{ fontWeight: 700, fontSize: '17px' }}>Inventory</div>
                <div style={{ fontSize: '13px', color: '#8a8f98' }}>
                  Current stock for this product.
                </div>
              </Box>
            </Box>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <label style={fieldLabelStyle}>Current Stock</label>
                <Box sx={inputBoxStyle(false)}>
                  <Inventory2OutlinedIcon sx={{ fontSize: 18, color: '#9aa0a6', marginLeft: '10px' }} />
                  <input
                    name="productCount"
                    placeholder="20"
                    value={updateProductData?.productCount || ''}
                    onChange={handleChange}
                    type="number"
                    min="0"
                    style={plainInputStyle}
                    disabled
                  />
                </Box>
                <div style={helperTextStyle}>
                  Use "Increase Count" on the products table to add stock.
                </div>
              </Grid>

              <Grid item xs={12} md={6}>
                <label style={fieldLabelStyle}>Reward Points</label>
                <Box sx={inputBoxStyle(false)}>
                  <input
                    name="rewardPoints"
                    placeholder="0"
                    value={updateProductData?.rewardPoints || ''}
                    onChange={handleChange}
                    type="number"
                    min="0"
                    style={plainInputStyle}
                  />
                </Box>
                <div style={helperTextStyle}>Reward points earned per purchase.</div>
              </Grid>
            </Grid>
          </Box>

          {/* 4. Staff Incentive */}
          <Box sx={sectionBoxStyle}>
            <Box sx={sectionHeaderStyle}>
              <Box sx={stepCircleStyle}>4</Box>
              <Box>
                <div style={{ fontWeight: 700, fontSize: '17px' }}>Staff Incentive</div>
                <div style={{ fontSize: '13px', color: '#8a8f98' }}>
                  Incentive for staff on sales of this product.
                </div>
              </Box>
            </Box>

            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={12} md={4}>
                <label style={fieldLabelStyle}>Incentive</label>
                <Box sx={inputBoxStyle(false)}>
                  <input
                    name="staffIncentive"
                    placeholder="10"
                    value={updateProductData?.staffIncentive || ''}
                    onChange={handleChange}
                    type="number"
                    min="0"
                    style={plainInputStyle}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <label style={fieldLabelStyle}>Type</label>
                <ToggleButtonGroup
                  value={updateProductData?.incentiveType || '%'}
                  exclusive
                  onChange={handleIncentiveTypeChange}
                  aria-label="incentive type"
                  fullWidth
                  sx={{
                    borderRadius: '6px',
                    height: '48px',
                    backgroundColor: '#f0f0f0',
                  }}
                >
                  {(incentiveTypes || ['%', 'INR']).map((type) => (
                    <ToggleButton
                      key={type}
                      value={type}
                      aria-label={type}
                      sx={{
                        color: '#000',
                        backgroundColor: '#e0e0e0',
                        height: '48px',
                        '&.Mui-selected': {
                          backgroundColor: '#6174DD',
                          color: '#fff',
                          '&:hover': {
                            backgroundColor: '#6174DD',
                          },
                        },
                        '&:not(.Mui-selected)': {
                          '&:hover': {
                            backgroundColor: '#d0d0d0',
                          },
                        },
                      }}
                    >
                      {type}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </Grid>
              <Grid item xs={12} md={4}>
                <label style={fieldLabelStyle}>&nbsp;</label>
                <Box
                  sx={{
                    background: '#eef8f0',
                    border: '1px solid #cfe8d4',
                    borderRadius: '8px',
                    padding: '6px 14px',
                    height: '48px',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <span style={{ fontSize: '11px', color: '#2e7d32' }}>Staff earns</span>
                  <span style={{ fontSize: '14px', fontWeight: 700, color: '#2e7d32' }}>
                    ₹{staffEarns} <span style={{ fontWeight: 400, fontSize: '10px' }}>per unit</span>
                  </span>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          {loading ? (
            <ShowLoader />
          ) : (
            <>
              <Button
                variant="outlined"
                sx={{ borderColor: '#6174DD', color: '#6174DD', padding: '10px 28px' }}
                onClick={handleCloseDialogue}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ background: '#6174DD', padding: '10px 28px' }}
                onClick={hadleupdateProductData}
              >
                Update
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Products;